<template>
	<DashboardCard icon="keyboard_command_key" :heading="messages.heading">
		<AppButtonGroup>
			<AppButton
				:disabled="!possibleActions.send"
				variant="primary"
				@click="$emit('send')"
			>
				{{ messages.buttons.send }}
			</AppButton>

			<RouterLink :to="editPageLink" style="text-decoration: none">
				<AppButton icon="edit" :disabled="!props.possibleActions.edit">
					{{ messages.buttons.edit }}
				</AppButton>
			</RouterLink>

			<AppButton :disabled="!possibleActions.revise" @click="$emit('revise')">
				{{ messages.buttons.revise }}
			</AppButton>

			<RouterLink :to="documentsPageLink" style="text-decoration: none">
				<AppButton> {{ messages.buttons.linkDocuments }} </AppButton>
			</RouterLink>

			<RouterLink :to="messagesPageLink" style="text-decoration: none">
				<AppButton> {{ messages.buttons.viewMessages }} </AppButton>
			</RouterLink>

			<RouterLink :to="offersPageLink" style="text-decoration: none">
				<AppButton> {{ messages.buttons.viewOffer }} </AppButton>
			</RouterLink>
		</AppButtonGroup>
	</DashboardCard>
</template>

<script lang="ts" setup>
import { computed } from "vue";

interface Props {
	possibleActions?: {
		send: boolean;
		revise: boolean;
		edit: boolean;
	};
	dossierDisplayId: string;
	applicationId: string;
}
const props = withDefaults(defineProps<Props>(), {
	possibleActions: () => ({
		send: false,
		revise: false,
		edit: false,
	}),
});
defineEmits<{
	send: [payload: void];
	revise: [payload: void];
}>();
const messages = {
	heading: "Acties",
	buttons: {
		send: "Versturen",
		edit: "Bewerken",
		revise: "Aanpassen",
		linkDocuments: "Documenten koppelen",
		viewMessages: "Bekijk HDN-berichten",
		viewOffer: "Bekijk offerte",
	},
};

const messagesPageLink = computed(() => ({
	name: "LoanApplicationMessagesPage",
	params: {
		dossierDisplayId: props.dossierDisplayId,
		loanApplicationId: props.applicationId,
	},
}));

const editPageLink = computed(() => ({
	name: "LoanApplicationEditPage",
	params: {
		dossierDisplayId: props.dossierDisplayId,
		loanApplicationId: props.applicationId,
	},
}));

const documentsPageLink = computed(() => ({
	name: "LoanApplicationDocumentsPage",
	params: {
		dossierDisplayId: props.dossierDisplayId,
		loanApplicationId: props.applicationId,
	},
}));

const offersPageLink = computed(() => ({
	name: "LoanOffersPage",
	params: {
		dossierDisplayId: props.dossierDisplayId,
		loanApplicationId: props.applicationId,
	},
}));
</script>
